export default __webpack_public_path__ + "static/media/19.2de77212.jpg";